"use strict";

var _templateObject, _templateObject2, _templateObject3;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ClientConfiguration = void 0;
var _tsRes = require("ts-res"),
  _types = require("./types"),
  _eventManager = require("../eventManager"),
  _constants = require("./constants"),
  _logging = require("../logging");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var ClientConfiguration = /*#__PURE__*/function () {
  function ClientConfiguration(a) {
    _classCallCheck(this, ClientConfiguration);
    var b = a.updateInterval,
      c = a.urlProvider,
      d = a.storage,
      e = a.requester,
      f = a.dataManager,
      g = a.eventSource,
      h = a.externalVisitorCodeManager,
      i = a.eventManager;
    _defineProperty(this, "updateConfigurationIntervalId", null), _defineProperty(this, "updateType", _types.UpdateType.Polling), _defineProperty(this, "configurationData", _constants.DEFAULT_CLIENT_CONFIGURATION), _defineProperty(this, "featureFlagsData", new Map()), _defineProperty(this, "isTargetedDeliveryRule", null), _defineProperty(this, "segmentsData", null), _defineProperty(this, "updateInterval", void 0), _defineProperty(this, "lastUpdate", void 0), _defineProperty(this, "storage", void 0), _defineProperty(this, "requester", void 0), _defineProperty(this, "eventSource", void 0), _defineProperty(this, "mappedRules", null), _defineProperty(this, "mappedExperiments", null), _defineProperty(this, "dataManager", void 0), _defineProperty(this, "visitorCodeManager", void 0), _defineProperty(this, "eventManager", void 0), _defineProperty(this, "urlProvider", void 0), this.urlProvider = c, this.requester = e, this.updateInterval = b, this.lastUpdate = new Date(), this.storage = d, this.dataManager = f, this.eventManager = i, this.visitorCodeManager = h, this.eventSource = g;
  }
  return _createClass(ClientConfiguration, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var a, _a, b;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _logging.KameleoonLogger.debug("CALL: ClientConfiguration.initialize()"), this.readStorageData();
              a = this.checkShouldUpdate();
              if (!a) {
                _context.next = 11;
                break;
              }
              _context.next = 5;
              return this.updateClientConfiguration();
            case 5:
              _a = _context.sent;
              if (_a.ok) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", (_logging.KameleoonLogger.error("Error occurred during client configuration update"), _a));
            case 8:
              b = _a.data;
              if (!b) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", (_logging.KameleoonLogger.debug("RETURN: ClientConfiguration.initialize()"), (0, _tsRes.Ok)()));
            case 11:
              return _context.abrupt("return", this.updateType !== _types.UpdateType.RealTime || this.eventSource.isOpen ? (this.updateType === _types.UpdateType.Polling && this.handlePollingUpdates(), _logging.KameleoonLogger.debug("RETURN: ClientConfiguration.initialize()"), (0, _tsRes.Ok)()) : (this.handleRealTimeUpdates(), _logging.KameleoonLogger.debug("RETURN: ClientConfiguration.initialize()"), (0, _tsRes.Ok)()));
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "cleanupHandlers",
    value: function cleanupHandlers() {
      this.eventSource.isOpen && this.eventSource.close(), this.updateConfigurationIntervalId && clearInterval(this.updateConfigurationIntervalId);
    }
  }, {
    key: "handleRealTimeUpdates",
    value: function handleRealTimeUpdates() {
      var _this = this;
      this.cleanupHandlers();
      var a = function a(_a2) {
        _this.updateClientConfiguration(_a2).then(function (b) {
          b.ok && _this.eventManager.fireEvent(_eventManager.EventType.ConfigurationUpdate, {
            timestamp: _a2
          });
        });
      };
      this.eventSource.open(a), this.eventSource.onError(function (a) {
        _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Error occurred during real-time update: ", ". Switching to polling updates while the connection is not restored."])), a), _this.updateType = _types.UpdateType.Polling, _this.handlePollingUpdates();
      });
    }
  }, {
    key: "handlePollingUpdates",
    value: function handlePollingUpdates() {
      this.cleanupHandlers();
      try {
        this.updateConfigurationIntervalId = setInterval(this.updateClientConfiguration.bind(this), this.updateInterval);
      } catch (a) {
        throw this.updateConfigurationIntervalId && clearInterval(this.updateConfigurationIntervalId), a;
      }
    }
  }, {
    key: "featureFlags",
    get: function get() {
      return this.featureFlagsData;
    }
  }, {
    key: "configuration",
    get: function get() {
      return this.configurationData.configuration;
    }
  }, {
    key: "segments",
    get: function get() {
      if (this.segmentsData) return this.segmentsData;
      var a = new Map();
      return this.featureFlagsData.forEach(function (b) {
        b.rules.forEach(function (b) {
          b.segment && !a.has(b.segment.id) && a.set(b.segment.id, b.segment);
        });
      }), this.segmentsData = a, a;
    }
  }, {
    key: "ruleMap",
    get: function get() {
      var a;
      if (null !== (a = this.mappedRules) && void 0 !== a && a.size) return this.mappedRules;
      var b = new Map();
      var _iterator = _createForOfIteratorHelper(this.featureFlags.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _a3 = _step.value;
          var _iterator2 = _createForOfIteratorHelper(_a3.rules),
            _step2;
          try {
            var _loop = function _loop() {
              var c = _step2.value;
              var d = c.id,
                e = c.experimentId,
                f = c.variationByExposition,
                g = new Map();
              f.forEach(function (a) {
                var b = a.variationKey,
                  c = a.variationId;
                "number" == typeof c && g.set(b, c);
              }), b.set(d, {
                featureId: _a3.id,
                experimentId: e,
                variations: g
              });
            };
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this.mappedRules = b, b;
    }
  }, {
    key: "experimentMap",
    get: function get() {
      var a;
      if (null !== (a = this.mappedExperiments) && void 0 !== a && a.size) return this.mappedExperiments;
      var b = new Map();
      var _iterator3 = _createForOfIteratorHelper(this.featureFlags.values()),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _a4 = _step3.value;
          var _iterator4 = _createForOfIteratorHelper(_a4.rules),
            _step4;
          try {
            var _loop2 = function _loop2() {
              var c = _step4.value;
              var a = c.experimentId,
                d = c.variationByExposition,
                e = new Map();
              d.forEach(function (a) {
                var b = a.variationKey,
                  c = a.variationId;
                "number" == typeof c && e.set(b, c);
              }), b.set(a, {
                type: c.type,
                variations: e
              });
            };
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return this.mappedExperiments = b, b;
    }
  }, {
    key: "isConsentRequired",
    get: function get() {
      return this.configuration.consentType === _types.ConsentType.Required;
    }
  }, {
    key: "hasAnyTargetedDeliveryRule",
    get: function get() {
      if (null !== this.isTargetedDeliveryRule) return this.isTargetedDeliveryRule;
      var _iterator5 = _createForOfIteratorHelper(this.featureFlags.values()),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var a = _step5.value;
          if (a.environmentEnabled && a.rules.some(function (a) {
            return a.type === _types.RuleType.TARGETED_DELIVERY;
          })) return !0;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return !1;
    }
  }, {
    key: "checkShouldUpdate",
    value: function checkShouldUpdate() {
      var a = this.configurationData.configuration;
      if (this.updateType = a.realTimeUpdate ? _types.UpdateType.RealTime : _types.UpdateType.Polling, !this.featureFlags.size) return !0;
      var b = this.lastUpdate.getTime(),
        c = Date.now() - this.updateInterval;
      return b < c;
    }
  }, {
    key: "readStorageData",
    value: function readStorageData() {
      _logging.KameleoonLogger.debug("CALL: ClientConfiguration.readStorageData()");
      var a = this.storage.read();
      if (a.ok) {
        var _a$data = a.data,
          b = _a$data.data,
          c = _a$data.lastUpdate;
        this.urlProvider.dataApiDomain = b.configuration.dataApiDomain;
        var d = b.featureFlags,
          _e = b.customData;
        null !== _e && void 0 !== _e && _e.length && (this.dataManager.customDataIndexes = _e);
        var _iterator6 = _createForOfIteratorHelper(d),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _a5 = _step6.value;
            this.featureFlagsData.set(_a5.featureKey, _a5);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        this.configurationData = b, this.updateConsentRequired(), this.lastUpdate = new Date(Date.parse(c));
      }
      _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: ClientConfiguration.readStorageData() -> (result: ", ")"])), a.ok);
    }
  }, {
    key: "updateClientConfiguration",
    value: function () {
      var _updateClientConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(a) {
        var b, c, d, _d$data, e, f, g, _iterator7, _step7, _b, h, i, j;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.requester.getClientConfiguration(a);
            case 2:
              d = _context2.sent;
              if (d.ok) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", this.featureFlags.size ? (_logging.KameleoonLogger.error("Error occurred while updating configuration. Existing configuration will be used as a fallback."), (0, _tsRes.Ok)(!0)) : d);
            case 5:
              _d$data = d.data, e = _d$data.configuration, f = _d$data.customData, g = _d$data.featureFlags;
              this.configurationData = {
                configuration: e,
                customData: f
              };
              _iterator7 = _createForOfIteratorHelper(g);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  _b = _step7.value;
                  this.featureFlagsData.set(_b.featureKey, _b);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              null !== f && void 0 !== f && f.length && (this.dataManager.customDataIndexes = f), this.dataManager.clearTrees(), null === (b = this.mappedRules) || void 0 === b ? void 0 : b.clear(), null === (c = this.experimentMap) || void 0 === c ? void 0 : c.clear(), this.isTargetedDeliveryRule = null, this.segmentsData = null;
              h = this.updateStorageData();
              if (h.ok) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return", h);
            case 13:
              i = e.realTimeUpdate ? _types.UpdateType.RealTime : _types.UpdateType.Polling, j = i !== this.updateType;
              _context2.t0 = j;
              if (!_context2.t0) {
                _context2.next = 20;
                break;
              }
              this.updateType = i;
              _logging.KameleoonLogger.info(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Configuration update type was toggled to ", ""])), i);
              _context2.next = 20;
              return this.initialize();
            case 20:
              this.updateConsentRequired();
              return _context2.abrupt("return", (0, _tsRes.Ok)(j));
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateClientConfiguration(_x) {
        return _updateClientConfiguration.apply(this, arguments);
      }
      return updateClientConfiguration;
    }()
  }, {
    key: "updateStorageData",
    value: function updateStorageData() {
      this.lastUpdate = new Date();
      var a = _objectSpread(_objectSpread({}, this.configurationData), {}, {
          featureFlags: Array.from(this.featureFlags.values())
        }),
        b = {
          data: a,
          lastUpdate: this.lastUpdate.toString()
        };
      return this.urlProvider.dataApiDomain = this.configurationData.configuration.dataApiDomain, this.storage.write(b);
    }
  }, {
    key: "updateConsentRequired",
    value: function updateConsentRequired() {
      this.visitorCodeManager.consentRequired = this.isConsentRequired && !this.hasAnyTargetedDeliveryRule;
    }
  }]);
}();
exports.ClientConfiguration = ClientConfiguration;